// extracted by mini-css-extract-plugin
export default {"text-wrapper-padding-override":"FoodFormats-module__text-wrapper-padding-override__ZzTIa"};